export const META_TYPE = 'scenarioAsset';
export const META_VER = 'v1';

export const CMD_SCENARIOASSET_REGISTRY_KEY = `${META_TYPE}:${META_VER}`;
